var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      attrs: {
        id: "basket-order-form",
        "data-validate": "true",
        onsubmit: "(function() {return false;})()"
      }
    },
    [
      _c("div", { staticClass: "cart-form" }, [
        _c("div", { staticClass: "cart-top cart-section" }, [
          _c("div", { staticClass: "cart-top__block" }, [
            _c("p", { staticClass: "cart-top__caption" }, [
              _vm._v("В корзине "),
              _c("span", { domProps: { innerHTML: _vm.basketItems.length } }),
              _vm._v(" товара\n          на сумму "),
              _c("span", {
                domProps: { innerHTML: _vm._f("price")(_vm.total.basePrice) }
              }),
              _vm._v(",  итого с учетом скидки  "),
              _c("span", {
                domProps: { innerHTML: _vm._f("price")(_vm.total.totalPrice) }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cart-top__return" }, [
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.setCurrentTab("basket")
                  }
                }
              },
              [_vm._v("Вернуться в корзину")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cart__delivery-notice" }, [
            _vm._v(
              "\n          При сумме заказа с учетом скидок от " +
                _vm._s(_vm.freeDeliverySum) +
                " руб. доставка 2–14 руб. в зависимости от региона\n      "
            )
          ]),
          _vm._v(" "),
          _vm.outletBasketTypes.length > 1
            ? _c("div", { staticClass: "cart__outlet-notice" }, [
                _vm._v(
                  "\n        В корзине есть товары из раздела Outlet. Эти товары будут помещены в отдельный заказ.\n      "
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "cart-personal cart-section" }, [
          _c("p", { staticClass: "cart__block-title container-tablet-lg" }, [
            _vm._v("Личные данные")
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "js-radio-tab-body cart-form__tab is-visible",
              attrs: { id: "cart-address-current" }
            },
            [
              _c(
                "div",
                { staticClass: "container-tablet-lg cart-personal__fields" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "field field--client-name cart-form__field cart-personal__field required"
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.firstName,
                            expression: "form.firstName"
                          }
                        ],
                        staticClass: "field__input",
                        attrs: {
                          type: "text",
                          name: "client-name",
                          id: "field-client-name",
                          value: "",
                          "data-parsley-name": "",
                          required: ""
                        },
                        domProps: { value: _vm.form.firstName },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.form,
                                "firstName",
                                $event.target.value
                              )
                            },
                            _vm.onInput
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "field__label",
                          attrs: { for: "field-client-name" }
                        },
                        [_vm._v("Имя")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "field field--client-surname cart-form__field cart-personal__field required"
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.lastName,
                            expression: "form.lastName"
                          }
                        ],
                        staticClass: "field__input",
                        attrs: {
                          type: "text",
                          name: "client-surname",
                          id: "field-client-surname",
                          value: "",
                          "data-parsley-name": "",
                          required: ""
                        },
                        domProps: { value: _vm.form.lastName },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.form,
                                "lastName",
                                $event.target.value
                              )
                            },
                            _vm.onInput
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "field__label",
                          attrs: { for: "field-client-surname" }
                        },
                        [_vm._v("Фамилия")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "cart-form__field-wrapper cart-personal__field required"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "field field--tel cart-form__field" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.phone,
                                expression: "form.phone"
                              },
                              {
                                name: "mask",
                                rawName: "v-mask",
                                value: "+7(###) ###-##-##",
                                expression: "'+7(###) ###-##-##'"
                              }
                            ],
                            staticClass: "field__input",
                            attrs: {
                              type: "tel",
                              name: "tel",
                              id: "field-tel",
                              "data-parsley-tel": "",
                              placeholder: "+7(000) 000-00-00",
                              required: ""
                            },
                            domProps: { value: _vm.form.phone },
                            on: {
                              input: [
                                function($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.form,
                                    "phone",
                                    $event.target.value
                                  )
                                },
                                _vm.onInput
                              ]
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "field__label field__label--up",
                              attrs: { for: "field-tel" }
                            },
                            [_vm._v("Телефон")]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._m(1)
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "field field--email cart-form__field cart-personal__field required"
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.email,
                            expression: "form.email"
                          }
                        ],
                        staticClass: "field__input",
                        attrs: {
                          type: "email",
                          name: "email",
                          id: "field-email",
                          value: "",
                          required: ""
                        },
                        domProps: { value: _vm.form.email },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) return
                              _vm.$set(_vm.form, "email", $event.target.value)
                            },
                            _vm.onInput
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "field__label",
                          attrs: { for: "field-email" }
                        },
                        [_vm._v("Электронная почта")]
                      )
                    ]
                  )
                ]
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "cart-delivery cart-section" }, [
          _c("p", { staticClass: "cart__block-title container-tablet-lg" }, [
            _vm._v("Доставка")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cart-form__delivery-types" }, [
            _c(
              "div",
              {
                staticClass: "container-tablet-lg cart-form__custom-radio-table"
              },
              _vm._l(Object(_vm.deliveryTypes), function(deliveryType) {
                return Object.keys(_vm.deliveryTypes).length === 1
                  ? _c("div", [
                      _c("div", { staticClass: "cart-form__delivery-info" }, [
                        _vm._m(2, true),
                        _vm._v(" "),
                        deliveryType.price.length > 1
                          ? _c(
                              "div",
                              {
                                staticClass: "cart-form__delivery-info-caption"
                              },
                              [
                                _vm._v(
                                  "\n                Сумма доставки по всем заказам\n              "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "cart-form__delivery-info-price" },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.getFullPriceDelivery(
                                    deliveryType.price
                                  ) || "Бесплатно"
                                ) +
                                "\n              "
                            )
                          ]
                        )
                      ])
                    ])
                  : _vm._l(Object(_vm.deliveryTypes), function(
                      deliveryType,
                      index
                    ) {
                      return _c(
                        "label",
                        {
                          staticClass:
                            "radio radio--radio-default cart-custom-new-check"
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.deliveryType,
                                expression: "form.deliveryType"
                              }
                            ],
                            staticClass: "radio__input",
                            attrs: {
                              type: "radio",
                              name: "radio-delivery-type",
                              "data-parsley-multiple": "radio-delivery-type"
                            },
                            domProps: {
                              value: index,
                              checked: _vm._q(_vm.form.deliveryType, index)
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(_vm.form, "deliveryType", index)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass:
                                "radio__label cart-custom-new-check__label"
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "cart-custom-new-check__description"
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(deliveryType.name) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "cart-custom-new-check__info-item",
                                domProps: {
                                  innerHTML: _vm._s(deliveryType.description)
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "cart-custom-check__info" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "cart-custom-new-check__info-item cart-custom-new-check__info-item--price"
                                },
                                [
                                  _vm._v(
                                    _vm._s(deliveryType.price || "Бесплатно")
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "cart-custom-check__border"
                          })
                        ]
                      )
                    })
              }),
              0
            ),
            _vm._v(" "),
            _vm._m(3)
          ]),
          _vm._v(" "),
          _vm.isNeedAddress
            ? _c(
                "p",
                { staticClass: "cart__block-title container-tablet-lg" },
                [_vm._v("Адрес получателя")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isNeedAddress
            ? _c(
                "div",
                { staticClass: "cart__block-title container-tablet-lg" },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isCantDelivery,
                          expression: "isCantDelivery"
                        }
                      ],
                      attrs: { id: "cantDeliveryMessage" }
                    },
                    [
                      _vm._v(
                        "\n                Доставка в данный регион временно недоступна.\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isCantTempDelivery && !_vm.isClosedToAll,
                          expression: "isCantTempDelivery && !isClosedToAll"
                        }
                      ],
                      staticStyle: { color: "red" },
                      attrs: { id: "cantTempDeliveryMessage" }
                    },
                    [
                      _vm._v(
                        "\n                Прием заказов в регионы временно ограничен. Оформить заказ можно с 1 января 2026 (обработка с 12.01).\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isClosedToAll,
                          expression: "isClosedToAll"
                        }
                      ],
                      staticStyle: { color: "red" },
                      attrs: { id: "isClosedToAllMessage" }
                    },
                    [
                      _vm._v(
                        "\n                Прием заказов временно ограничен. Оформить заказ можно с 1 января 2026 (обработка с 12.01).\n            "
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isNeedAddress
            ? _c(
                "div",
                { staticClass: "cart-form__address cart-personal__fields" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "field field&#45;&#45;client-name cart-personal__field required cart-form__field cart-form__field cart-form__field--city"
                    },
                    [
                      _c("VueSuggestions", {
                        staticClass: "field__input",
                        attrs: {
                          id: "city",
                          model: _vm.inputCity,
                          placeholder: "Начните вводить",
                          required: "",
                          options: _vm.citySuggestionOptions,
                          "data-parsley-debounce": "500"
                        },
                        on: {
                          "update:model": function($event) {
                            _vm.inputCity = $event
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        { staticClass: "field__label field__label--up" },
                        [_vm._v("Населенный пункт")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "field field&#45;&#45;client-name cart-personal__field required cart-form__field cart-form__field--street"
                    },
                    [
                      _c("VueSuggestions", {
                        staticClass: "field__input",
                        attrs: {
                          id: "street",
                          model: _vm.inputStreet,
                          placeholder: "Начните вводить",
                          required: "",
                          options: _vm.streetSuggestionOptions,
                          "data-parsley-debounce": "500"
                        },
                        on: {
                          "update:model": function($event) {
                            _vm.inputStreet = $event
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        { staticClass: "field__label field__label--up" },
                        [_vm._v("Улица")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "field field&#45;&#45;client-name cart-personal__field required cart-form__field cart-form__field--house"
                    },
                    [
                      _c("VueSuggestions", {
                        staticClass: "field__input",
                        attrs: {
                          id: "house",
                          model: _vm.form.house,
                          placeholder: "",
                          required: "",
                          options: _vm.houseSuggestionOptions
                        },
                        on: {
                          "update:model": function($event) {
                            return _vm.$set(_vm.form, "house", $event)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        { staticClass: "field__label field__label--up" },
                        [_vm._v("Дом")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "field field&#45;&#45;client-name cart-personal__field cart-form__field cart-form__field--room"
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.flat,
                            expression: "form.flat"
                          }
                        ],
                        staticClass: "field__input",
                        attrs: {
                          type: "text",
                          name: "client-name",
                          id: "flat"
                        },
                        domProps: { value: _vm.form.flat },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.form, "flat", $event.target.value)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "field__label field__label--up",
                          attrs: { for: "flat" }
                        },
                        [_vm._v("Квартира")]
                      )
                    ]
                  )
                ]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "cart-section cart-payment" }, [
          _c("p", { staticClass: "cart__block-title container-tablet-lg" }, [
            _vm._v("Оплата")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "container-tablet-lg" }, [
            _c(
              "fieldset",
              {
                staticClass:
                  "radio radio--radio-payment cart-form__radio cart-form__custom-radio-table"
              },
              _vm._l(Object(_vm.paymentTypes), function(paymentType) {
                return Object.keys(_vm.paymentTypes).length === 1
                  ? _c("div", [
                      _c("div", { staticClass: "cart-form__delivery-info" }, [
                        _c(
                          "div",
                          { staticClass: "cart-form__delivery-info-caption" },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(paymentType.name) +
                                "\n              "
                            )
                          ]
                        )
                      ])
                    ])
                  : _vm._l(Object(_vm.paymentTypes), function(
                      paymentType,
                      index
                    ) {
                      return [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.paymentType,
                              expression: "form.paymentType"
                            }
                          ],
                          staticClass: "radio__input",
                          attrs: {
                            type: "radio",
                            id: `radio-radio-payment-${index}`,
                            name: "radio-radio-payment",
                            checked: "checked"
                          },
                          domProps: {
                            value: index,
                            checked: _vm._q(_vm.form.paymentType, index)
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(_vm.form, "paymentType", index)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "radio__label cart-custom-new-radio",
                            attrs: { for: `radio-radio-payment-${index}` }
                          },
                          [_vm._v(_vm._s(paymentType.name) + "\n            ")]
                        )
                      ]
                    })
              }),
              0
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "cart-total-section" }, [
          _c("p", { staticClass: "cart__block-title container-tablet-lg" }, [
            _vm._v("Сведения о заказе")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cart-total" }, [
            _c(
              "div",
              { staticClass: "cart-total__wrapper" },
              [
                _c("div", { staticClass: "cart-total__block" }, [
                  _c("p", { staticClass: "cart-total__caption" }, [
                    _vm._v("Сумма заказа")
                  ]),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "cart-total__price",
                    domProps: {
                      innerHTML: _vm._f("price")(_vm.total.basePrice)
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "cart-total__block" }, [
                  _c("p", { staticClass: "cart-total__caption" }, [
                    _vm._v("Скидка")
                  ]),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "cart-total__price",
                    domProps: { innerHTML: _vm._f("price")(_vm.total.discount) }
                  })
                ]),
                _vm._v(" "),
                _vm._l(_vm.getDeliveryPrice, function(priceValue) {
                  return _c("div", { staticClass: "cart-total__block" }, [
                    _c("p", { staticClass: "cart-total__caption" }, [
                      _vm._v("Доставка\n              "),
                      _vm.getDeliveryPrice.length > 1 && priceValue.status
                        ? _c("span", [
                            _vm._v(
                              "\n                Заказ - " +
                                _vm._s(priceValue.status) +
                                "\n              "
                            )
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("p", {
                      staticClass: "cart-total__price",
                      domProps: { innerHTML: _vm._f("price")(priceValue.price) }
                    })
                  ])
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "cart-total__block cart-total__sum" },
                  [
                    _c("div", { staticClass: "cart-total__sum-caption" }, [
                      _vm._v("Итого к оплате")
                    ]),
                    _vm._v(" "),
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._f("price")(_vm.getTotalPrice)
                      }
                    })
                  ]
                )
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "cart-total-textarea field field&#45;&#45;client-comment cart-form__field&#45;&#45;long"
              },
              [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.comment,
                      expression: "form.comment"
                    }
                  ],
                  staticClass: "field__input field__input&#45;&#45;textarea",
                  attrs: {
                    name: "client-comment",
                    id: "field-client-comment",
                    rows: "1"
                  },
                  domProps: { value: _vm.form.comment },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "comment", $event.target.value)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "field__label",
                    attrs: { for: "field-client-comment" }
                  },
                  [_vm._v("Комментарий к заказу")]
                )
              ]
            ),
            _vm._v(" "),
            _vm._m(4),
            _vm._v(" "),
            _c("div", { staticClass: "cart__btn-container" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn--blue cart__btn",
                  attrs: { type: "button" },
                  on: { click: _vm.createOrder }
                },
                [_vm._v("Оформить заказ\n          ")]
              )
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "cart-personal__sub-title" }, [
      _vm._v("Поля, отмеченные "),
      _c("span", { staticClass: "circle" }),
      _vm._v(" обязательны для заполнения")
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "cart-form__field-tooltip tooltip tooltip--message",
        attrs: {
          "data-tooltip-text":
            "Номер телефона позволит Вам получать новую свежую информацию от нас"
        }
      },
      [
        _c(
          "button",
          {
            staticClass: "tooltip__trigger cart-form__field-tooltip-btn",
            attrs: { type: "button" }
          },
          [_vm._v("Зачем нужен номер телефона?\n              ")]
        )
      ]
    )
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "cart-form__delivery-info-caption" }, [
      _c("a", { attrs: { href: "/customers/?faq=444" } }, [
        _vm._v("Сроки доставки")
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "js-cart-points-map cart__points-map" }, [
      _c("div", { staticClass: "container-tablet-lg" }, [
        _c("div", { staticClass: "selected-shop-info" }, [
          _c("div", {
            staticClass: "js-selected-shop-info selected-shop-info__content"
          }),
          _vm._v(" "),
          _c("div", { staticClass: "selected-shop-info__change" }, [
            _c(
              "button",
              {
                staticClass: "link",
                attrs: {
                  "data-href": "#popup-map-select-shop",
                  type: "button",
                  "data-popup": "open"
                }
              },
              [_vm._v("Выбрать другой магазин\n                ")]
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "ylist ylist--selected-shop selected-shop",
            attrs: {
              id: "selected-shop",
              "data-switch": "#selected-shop-switch"
            }
          },
          [
            _c("div", {
              staticClass: "ylist__map-container is-loading",
              attrs: { id: "selected-shop-map" }
            })
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "cart__agreements container-tablet-lg" }, [
      _c("fieldset", { staticClass: "checkbox cart__checkbox" }, [
        _c("legend", { staticClass: "is-hidden" }, [
          _vm._v("Согласие с условиями передачи данных")
        ]),
        _vm._v(" "),
        _c("input", {
          staticClass: "checkbox__input",
          attrs: {
            type: "checkbox",
            name: "checkbox-agreement",
            id: "checkbox-agreement",
            value: "1",
            "data-parsley-multiple": "checkbox-agreement",
            required: "",
            checked: "checked"
          }
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "checkbox__label",
            attrs: { for: "checkbox-agreement" }
          },
          [
            _vm._v("\n                    Я даю \n                    "),
            _c(
              "a",
              {
                staticClass: "cart__checkbox-link",
                attrs: { href: "/customers/?agreement_form", target: "_blank" }
              },
              [_vm._v("согласие на обработку")]
            ),
            _vm._v(
              "\n                    моих персональных данных ООО «Пьер Фабр» и соглашаюсь с \n                    "
            ),
            _c(
              "a",
              {
                staticClass: "cart__checkbox-link",
                attrs: { href: "/customers/?agreement", target: "_blank" }
              },
              [_vm._v("\n                        Пользовательским соглашением")]
            ),
            _vm._v("\n                    и \n                    "),
            _c(
              "a",
              {
                staticClass: "cart__checkbox-link",
                attrs: { href: "/customers/?policy", target: "_blank" }
              },
              [
                _vm._v(
                  "\n                        Политикой в отношении обработки персональных данных."
                )
              ]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("fieldset", { staticClass: "checkbox cart__checkbox" }, [
        _c("legend", { staticClass: "is-hidden" }, [
          _vm._v("Согласие с условиями передачи данных")
        ]),
        _vm._v(" "),
        _c("input", {
          staticClass: "checkbox__input",
          attrs: {
            type: "checkbox",
            name: "checkbox-spec",
            id: "checkbox-spec",
            value: "1",
            "data-parsley-multiple": "checkbox-spec",
            checked: "checked"
          }
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "checkbox__label tooltip tooltip--message",
            attrs: {
              "data-tooltip-text":
                "Подписываясь на рассылку, Вы всегда будете в курсе наших самых выгодных предложений! Самая свежая информация о средствах по уходу за лицом, волосами и телом, отправленная по электронной почте, а также интересные статьи о здоровье и красоте ждут вас.",
              for: "checkbox-spec"
            }
          },
          [
            _vm._v(
              '\n                Даю согласие ООО "Пьер Фабр" на получение новостных и рекламных рассылок.\n              '
            ),
            _c(
              "span",
              { staticClass: "tooltip__trigger cart-form__field-tooltip-btn" },
              [_vm._v("Подробнее")]
            )
          ]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }